import type { CardTransaction, CardTransactionMetadata } from 'services/CardService'
import { formatCurrency } from '../../helpers/cards'

const MERCHANT_FIELDS = [
  'merchantName',
  'merchantCategory',
  'merchantCategoryCode',
  'localCurrency',
] as const satisfies ReadonlyArray<keyof CardTransactionMetadata>

type MerchantField = (typeof MERCHANT_FIELDS)[number]

export interface MerchantItem {
  id: MerchantField
  value: string
}

export const useCardTransactionDetails = (transaction: CardTransaction) => {
  const { metadata, reportData } = transaction

  const conversionRate =
    metadata?.localAmount && metadata?.usdAmount && metadata?.localCurrency
      ? `1 ${metadata?.localCurrency.toUpperCase()} = ${Number((metadata.localAmount / metadata.usdAmount).toFixed(2))} ${transaction.asset}`
      : undefined

  const localAmount =
    metadata?.localAmount && metadata?.localCurrency
      ? formatCurrency(metadata.localAmount, metadata.localCurrency)
      : undefined

  const authorizedAmount = formatCurrency(transaction.authorizedAmount, 'USD')

  const settledAmount = transaction.settledAmount
    ? formatCurrency(transaction.settledAmount, transaction.asset)
    : undefined

  const fee =
    reportData?.fxFee !== undefined && metadata?.localCurrency
      ? formatCurrency(reportData.fxFee, metadata.localCurrency)
      : undefined

  const merchantItems: MerchantItem[] = MERCHANT_FIELDS.map(id => ({
    id,
    value: id === 'localCurrency' ? metadata?.[id]?.toUpperCase() : metadata?.[id],
  })).filter((item): item is MerchantItem => Boolean(item.value))

  return {
    conversionRate,
    localAmount,
    authorizedAmount,
    settledAmount,
    fee,
    merchantItems,
  }
}
